// Farm selection resolution + persistence (D-14). Resolution order:
// ?farm= in the URL, then the last farm viewed (localStorage), then the
// olive farm default. Every localStorage access is wrapped in try/catch —
// private browsing / storage-disabled must never crash the page (T-01-09).

export const FARM_ID_RE = /^[a-z0-9-]{1,32}$/;
export const FARM_STORAGE_KEY = 'weather-farm';
export const DEFAULT_FARMS: Array<{ id: string; name: string }> = [
  { id: 'olive', name: 'Olive farm' },
  { id: 'foliage', name: 'Foliage farm' },
];

export function resolveInitialFarm(): string {
  const fromUrl = new URLSearchParams(window.location.search).get('farm');
  if (fromUrl && FARM_ID_RE.test(fromUrl)) return fromUrl;

  try {
    const stored = localStorage.getItem(FARM_STORAGE_KEY);
    if (stored && FARM_ID_RE.test(stored)) return stored;
  } catch {
    // Storage disabled/unavailable — fall through to the default.
  }

  return 'olive';
}

export function persistFarm(id: string): void {
  const url = new URL(window.location.href);
  url.searchParams.set('farm', id);
  history.replaceState(null, '', url);

  try {
    localStorage.setItem(FARM_STORAGE_KEY, id);
  } catch {
    // Storage disabled/unavailable — URL persistence above still works.
  }
}
